<script setup>
import { ref, computed } from 'vue'
import StarLine from '@/components/stars/StarLine.vue'

import { getStarsNumberOrString, getRewievsComments } from '@/utils/additional.js'

import { useDataScore } from '@/stores/dataScore.js'
const scoreStore = useDataScore();
scoreStore.init()

const appScore = window.appScores


const props = defineProps({
   additionalRatings: [String, null],
})

// let starsTotal = ref(scoreStore.starsTotal)
// let starsArrayPresents = ref(scoreStore.starsArrayPresents)

// const [starsTotal, starsArrayPresents] = getStarsTotal(appScore.arraySteps)

// function getStarsTotal(array) {
//    if (array.length !== 5)
//       return 5

//    let total = 0
//    let score = 0

//    const arrayPersents = [0, 0, 0, 0, 0]

//    for (let i = 0; i < array.length; i++) {
//       total += array[i]
//       score += array[i] * (i + 1)
//    }

//    const totalScore = score / total

//    for (let i = 0; i < array.length; i++) {
//       arrayPersents[i] = array[i] / total
//    }

//    console.log(score / total);

//    return [
//       totalScore.toFixed(1),
//       arrayPersents
//    ]
// }

function getStyleSlider(i) {
   let persents = (scoreStore.arrayPersents[i - 1] * 100).toFixed(3)

   return `width: ${persents}%`
   // return `width: 50%`
}

// const titleComments = ref(11)

function getTotalScore(score) {
   return getStarsNumberOrString(score, props.additionalRatings)
}

</script>

<template>
   <div class="rating_block">

      <div class="rating_block__left-column">

         <div>
            <div class="rating_left--score">{{ getTotalScore(scoreStore.totalScore) }}</div>
            <div class="rating_left--stars">
               <StarLine :size="16" :score="scoreStore.totalScore" />
            </div>
            <div class="rating_left--discription">
               <!-- {{ appScore.description }} -->
               <!-- {{ titleComments }} -->

               {{ getRewievsComments($t('sub_header.commentsCount'), $t('sub_header.titleComments')) }}
            </div>
         </div>
      </div>

      <div class="rating_block__right-column">
         <div class="rating_graph">
            <div class="rating_graph--title"> 5 </div>
            <div class="rating_graph--graph">
               <div class="rating_graph--slider" :style="getStyleSlider(5)"></div>
            </div>
         </div>

         <div class="rating_graph">
            <div class="rating_graph--title"> 4 </div>
            <div class="rating_graph--graph">
               <div class="rating_graph--slider" :style="getStyleSlider(4)"></div>
            </div>
         </div>

         <div class="rating_graph">
            <div class="rating_graph--title"> 3 </div>
            <div class="rating_graph--graph">
               <div class="rating_graph--slider" :style="getStyleSlider(3)"></div>
            </div>
         </div>

         <div class="rating_graph">
            <div class="rating_graph--title"> 2 </div>
            <div class="rating_graph--graph">
               <div class="rating_graph--slider" :style="getStyleSlider(2)"></div>
            </div>
         </div>

         <div class="rating_graph">
            <div class="rating_graph--title"> 1 </div>
            <div class="rating_graph--graph">
               <div class="rating_graph--slider" :style="getStyleSlider(1)"></div>
            </div>
         </div>
      </div>

   </div>

</template>

<style lang="scss" scoped>
.rating_graph {
   width: 100%;
   display: flex;
   align-items: center;

   &--title {
      font-size: 14px;
      color: var(--data_color_additional_text);
   }

   // .rating_graph--graph
   &--graph {
      // background-color: rgb(232, 234, 237);
      background-color: var(--data_rating_graph_background);
      width: 100%;
      margin: 0px 16px;
      border-radius: 50px;
      content: " ";
      height: 10px;
   }

   &--slider {
      background-color: var(--app_button_main_color);
      border-radius: 50px;
      width: 10%;
      height: 10px;
   }
}

.rating_block {
   display: grid;
   grid-template-columns: 120px 1fr;
   height: 106px;
   width: 100%;
}

.rating_block__ {

   &left-column,
   &right-column {
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: space-around;
      flex-wrap: nowrap;
      flex-direction: column;
      gap: 0px;
   }
}

.rating_left- {
   &-score {
      //color: rgb(32, 33, 36);
      // fill: rgb(32, 33, 36);
      // stop-color: rgb(32, 33, 36);
      font-family: "Google Sans Display", Roboto, Arial, sans-serif;
      line-height: 4rem;
      font-size: 3.5rem;
      letter-spacing: 0;
      font-weight: 400;
   }

   &-discription {
      fill: var(--data_color_additional_text);
      stop-color: var(--data_color_additional_text);
      font-family: Roboto, Arial, sans-serif;
      line-height: 1rem;
      font-size: .75rem;
      letter-spacing: .025em;
      font-weight: 400;
      margin-top: 0.5rem;
      color: var(--data_color_additional_text);
   }

   &-stars {
      display: flex;
   }
}

.deXnLd {
   height: 16px;
   width: 16px;
}

.Z1Dz7b {
   color: var(--app_button_main_color);
   fill: var(--app_button_main_color);
}

.Z1Dz7b_disabled {
   fill: rgb(185, 0, 0);
}
</style>
